import React from 'react';
import { FAQItem } from './FAQItem';
export const FAQSection = () => {
  const faqs = [{
    question: 'What is the $100M Sales Team Operating System?',
    answer: 'A 120-day, done‑with‑you install of your sales operating system: comp, KPIs, dashboards, cadences, CRM rules, and culture, so your current 5–30 reps perform like your current top 10%.'
  }, {
    question: 'How is this different from sales training or a course?',
    answer: "Training changes what reps know for a day. An operating system changes what they do every day. We don't sell events or videos – we design and install the way your team runs."
  }, {
    question: 'Do you recruit setters/closers or run an outsourced sales team?',
    answer: "No. We don't place reps and we don't run your team for you. You already have 5–30 reps and leads. We fix the system they run in."
  }, {
    question: 'Who is this for?',
    answer: 'Founders / heads of sales who:\n\nDo $1M+ per year.\n\nHave 5–30 full‑time reps taking calls.\n\nSell online coaching/consulting or other high‑ticket services.\n\nHave consistent lead flow and a proven offer.'
  }, {
    question: 'Who is this NOT for?',
    answer: "Not a fit if you:\n\nAre still doing founder‑led sales with <5 reps.\n\nDon't have steady lead flow yet.\n\nWant recruiting, setters/closers, or marketing built from scratch.\n\nJust want a one‑day motivational session."
  }, {
    question: 'What results should we expect?',
    answer: 'The goal is simple:\n\nMore revenue per rep on the same leads.\n\nMore reps at or above quota.\n\nA higher bar for "top producer," not just a slightly higher average.'
  }, {
    question: "How much of my team's time does this take?",
    answer: 'We work mainly with you and your sales leader in weekly sessions. Reps feel it through tighter comp, KPIs, meetings, and CRM usage – not hours a day off the phones.'
  }, {
    question: 'Will this work in my niche?',
    answer: 'If you sell high‑ticket B2B or B2C via an inside/hybrid team of 5–30 reps and have leads, the physics are the same. We tailor metrics and playbooks to your model.'
  }, {
    question: 'What happens on the Sales Operating System Audit Call?',
    answer: "We:\n\nConfirm your revenue, team, and lead flow.\n\nReview your current comp, KPIs, dashboards, cadence, CRM.\n\nShow you where the real leaks are and whether the $100M system makes sense.\n\nIf it's not a fit, we'll tell you."
  }];
  return <div className="w-full py-16 sm:py-24" data-id="element-67">
      <div className="max-w-4xl mx-auto px-4" data-id="element-68">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-black mb-8 sm:mb-12 text-[#F5F5F7] text-center leading-tight" data-id="element-69">
          Frequently Asked Questions
        </h2>
        <div className="rounded-xl" data-id="element-70">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-71" />)}
        </div>
      </div>
    </div>;
};